import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Select, Table } from 'antd';
import Breadcrumb from '../../components/BreadCrumb/BreadCrumb';
import ReportPageIcon from '../../assets/icons/reports-active.svg';
import CustomMultiSelectDropdown from '../../components/AnticipatedOrderComps/CustomMultiSelectDropdown';
// import CustomSelectWithFilter from '../../components/Common/CustomSelect/CustomSelectWithFilter';
import { getAllUnits } from '../../redux/unitSlice/unitSlice';
import axiosInstance from '../../utils/axiosInstance';
import Loader from '../../components/Common/LoadingSpinner/LoadingSpinner';
import openNotification from '../../components/Common/OpenNotification';

const UnitLevelReportPage = () => {
        const dispatch = useDispatch();
        const { allUnitsList } = useSelector((state) => state.unit);
        const [allUnitListing, setAllUnitListing] = useState([]);
        const [reportType, setReportType] = useState('revenue'); // Default to first option
        const [selectedUnits, setSelectedUnits] = useState("");
        const [reportType1, setReportType1] = useState('revenue'); // Default to first option
        const [selectedUnits1, setSelectedUnits1] = useState("");
        
        const [packageProjectData, setPackageProjectData] = useState([]);
        const [labels, setLabels] = useState([]);
        const [projectPackageData, setProjectPackageData] = useState([]);
        const [projectPackageLabels, setProjectPackageLabels] = useState([]);
        const [loading, setLoading] = useState(false);
        const [loading1, setLoading1] = useState(false);
        const defaultUnitSet = useRef(false);
        // Report type options
        const reportTypeOptions = [
                { value: 'revenue', label: 'Revenue' },
                { value: 'project_cost', label: 'Project Cost' },
                { value: 'net_billing', label: 'Net Billing' },
                { value: 'cash_inflow', label: 'Cash Inflow' },
        ];

        // Generate columns for Project Package Wise table
        const generateProjectPackageColumns = (labels) => {
                const columns = [
                        {
                                title: 'IO_NO',
                                dataIndex: 'IO_NO',
                                key: 'IO_NO',
                                width: 150,
                                fixed: 'left',
                                align: 'center',
                                onCell: (record, rowIndex) => {
                                        let rowSpan = 1;
                                        const currentProject = `${record.IO_NO}-${record.REV_NO}-${record.PROJ_NAME}`;

                                        // Count consecutive rows with same project
                                        for (let i = rowIndex + 1; i < projectPackageData?.length; i++) {
                                                const nextProject = `${projectPackageData[i].IO_NO}-${projectPackageData[i].REV_NO}-${projectPackageData[i].PROJ_NAME}`;
                                                if (nextProject === currentProject) {
                                                        rowSpan++;
                                                } else {
                                                        break;
                                                }
                                        }
                                        // If previous row has same project, hide this cell
                                        if (rowIndex > 0) {
                                                const prevProject = `${projectPackageData[rowIndex - 1].IO_NO}-${projectPackageData[rowIndex - 1].REV_NO}-${projectPackageData[rowIndex - 1].PROJ_NAME}`;
                                                if (prevProject === currentProject) {
                                                        return { rowSpan: 0 };
                                                }
                                        }

                                        return { rowSpan };
                                },
                        },
                        {
                                title: 'REV_NO',
                                dataIndex: 'REV_NO',
                                key: 'REV_NO',
                                width: 100,
                                fixed: 'left',
                                align: 'center',
                                onCell: (record, rowIndex) => {
                                        let rowSpan = 1;
                                        const currentProject = `${record.IO_NO}-${record.REV_NO}-${record.PROJ_NAME}`;

                                        for (let i = rowIndex + 1; i < projectPackageData?.length; i++) {
                                                const nextProject = `${projectPackageData[i].IO_NO}-${projectPackageData[i].REV_NO}-${projectPackageData[i].PROJ_NAME}`;
                                                if (nextProject === currentProject) {
                                                        rowSpan++;
                                                } else {
                                                        break;
                                                }
                                        }

                                        if (rowIndex > 0) {
                                                const prevProject = `${projectPackageData[rowIndex - 1].IO_NO}-${projectPackageData[rowIndex - 1].REV_NO}-${projectPackageData[rowIndex - 1].PROJ_NAME}`;
                                                if (prevProject === currentProject) {
                                                        return { rowSpan: 0 };
                                                }
                                        }

                                        return { rowSpan };
                                },
                        },
                        {
                                title: 'PROJ_NAME',
                                dataIndex: 'PROJ_NAME',
                                key: 'PROJ_NAME',
                                width: 250,
                                fixed: 'left',
                                align: 'center',
                                onCell: (record, rowIndex) => {
                                        let rowSpan = 1;
                                        const currentProject = `${record.IO_NO}-${record.REV_NO}-${record.PROJ_NAME}`;

                                        for (let i = rowIndex + 1; i < projectPackageData?.length; i++) {
                                                const nextProject = `${projectPackageData[i].IO_NO}-${projectPackageData[i].REV_NO}-${projectPackageData[i].PROJ_NAME}`;
                                                if (nextProject === currentProject) {
                                                        rowSpan++;
                                                } else {
                                                        break;
                                                }
                                        }

                                        if (rowIndex > 0) {
                                                const prevProject = `${projectPackageData[rowIndex - 1].IO_NO}-${projectPackageData[rowIndex - 1].REV_NO}-${projectPackageData[rowIndex - 1].PROJ_NAME}`;
                                                if (prevProject === currentProject) {
                                                        return { rowSpan: 0 };
                                                }
                                        }

                                        return { rowSpan };
                                },
                        },
                        {
                                title: 'NATURE',
                                dataIndex: 'NATURE',
                                key: 'NATURE',
                                width: 150,
                                fixed: 'left',
                                align: 'center',
                        },
                ];

                // Add dynamic columns for each label
                labels.forEach((label, index) => {
                        columns.push({
                                title: label,
                                dataIndex: `label_${index}`,
                                key: `label_${index}`,
                                width: 120,
                                align: 'center',
                                render: (value) => {
                                        if (value === null || value === undefined) return '--';
                                        return typeof value === 'number' ? value.toLocaleString() : value;
                                },
                        });
                });

                return columns;
        };

        // Generate columns for Package Project Wise table
        const generatePackageProjectColumns = (labels) => {
                const columns = [
                        {
                                title: 'NATURE',
                                dataIndex: 'NATURE',
                                key: 'NATURE',
                                width: 150,
                                fixed: 'left',
                                align: 'center',
                                onCell: (record, rowIndex) => {
                                        let rowSpan = 1;
                                        const currentNature = record.NATURE;

                                        // Count consecutive rows with same NATURE
                                        for (let i = rowIndex + 1; i < packageProjectData?.length; i++) {
                                                if (packageProjectData[i].NATURE === currentNature) {
                                                        rowSpan++;
                                                } else {
                                                        break;
                                                }
                                        }

                                        // If previous row has same NATURE, hide this cell
                                        if (rowIndex > 0 && packageProjectData[rowIndex - 1].NATURE === currentNature) {
                                                return { rowSpan: 0 };
                                        }

                                        return { rowSpan };
                                },
                        },
                        {
                                title: 'PROJ_NAME',
                                dataIndex: 'PROJ_NAME',
                                key: 'PROJ_NAME',
                                width: 250,
                                fixed: 'left',
                                align: 'center',
                        },
                        {
                                title: 'IO_NO',
                                dataIndex: 'IO_NO',
                                key: 'IO_NO',
                                width: 150,
                                fixed: 'left',
                                align: 'center',
                        },
                        {
                                title: 'REV_NO',
                                dataIndex: 'REV_NO',
                                key: 'REV_NO',
                                width: 100,
                                fixed: 'left',
                                align: 'center',
                        },
                ];

                // Add dynamic columns for each label
                labels.forEach((label, index) => {
                        columns.push({
                                title: label,
                                dataIndex: `label_${index}`,
                                key: `label_${index}`,
                                width: 120,
                                align: 'center',
                                render: (value) => {
                                        if (value === null || value === undefined) return '--';
                                        return typeof value === 'number' ? value.toLocaleString() : value;
                                },
                        });
                });

                return columns;
        };

        // Fetch units on component mount
        useEffect(() => {
                dispatch(getAllUnits());
        }, [dispatch]);

        // Update unit listing when allUnitsList changes
        useEffect(() => {
                if (allUnitsList?.length) {
                        setAllUnitListing(allUnitsList);
                }
        }, [allUnitsList]);

        const handleReportTypeChange = (value) => {
                console.log('Report Type changed:', value);
                setReportType(value);
        };
        const handleReportTypeChange1 = (value) => {
                console.log('Report Type changed:', value);
                setReportType1(value);
        };

        const handleUnitsChange = useCallback((value) => {
                console.log('Units changed:', value);
                setSelectedUnits(value);
        }, []);
        const handleUnitsChange1 = (value) => {
                console.log('Units changed:', value);
                setSelectedUnits1(value);
        };

        // Set default unit selection when units are loaded (only once)
        useEffect(() => {
                if (allUnitListing?.length > 0 && !defaultUnitSet.current && allUnitListing[0]?.MNF_UNIT) {
                        const firstUnit = allUnitListing[0].MNF_UNIT;
                        setSelectedUnits(firstUnit);
                        setSelectedUnits1(firstUnit);
                        // Trigger onChange to update the dropdown's internal state
                        handleUnitsChange(firstUnit);
                        defaultUnitSet.current = true;
                }
        }, [allUnitListing]);
        console.log('Selected Units:', selectedUnits);
        // Transform API response data for Project Package Wise table format with rowSpan for IO_NO, REV_NO, PROJ_NAME
        const transformProjectPackageData = useCallback((items) => {
                const tableData = [];
                let globalIndex = 0;
                items.forEach((item, itemIndex) => {
                        const ioNo = item.IO_NO || '--';
                        const revNo = item.REV_NO || '--';
                        const projName = item.PROJ_NAME || '--';
                        const packages = item.packages || [];

                        packages.forEach((pkg, packageIndex) => {
                                const row = {
                                        key: `${itemIndex}-${ioNo}-${revNo}-${packageIndex}-${globalIndex}`,
                                        IO_NO: ioNo,
                                        REV_NO: revNo,
                                        PROJ_NAME: projName,
                                        NATURE: pkg.NATURE || '--',
                                        ...pkg.values.reduce((acc, value, index) => {
                                                acc[`label_${index}`] = value || 0;
                                                return acc;
                                        }, {}),
                                };
                                tableData.push(row);
                                globalIndex++;
                        });
                });
                setProjectPackageData(tableData);
        }, []);

        // Transform API response data into table format with rowSpan for NATURE
        const transformDataForTable = useCallback((items) => {
                const tableData = [];
                let globalIndex = 0;
                items.forEach((item, itemIndex) => {
                        const nature = item.NATURE;
                        const projects = item.projects || [];

                        projects.forEach((project, projectIndex) => {
                                const row = {
                                        key: `${itemIndex}-${nature}-${projectIndex}-${globalIndex}`,
                                        NATURE: nature,
                                        IO_NO: project.IO_NO || '--',
                                        REV_NO: project.REV_NO || '--',
                                        PROJ_NAME: project.PROJ_NAME || '--',
                                        ...project.values.reduce((acc, value, index) => {
                                                acc[`label_${index}`] = value || 0;
                                                return acc;
                                        }, {}),
                                };
                                tableData.push(row);
                                globalIndex++;
                        });
                });
                setPackageProjectData(tableData);
        }, []);

        // Fetch project package wise data
        const fetchProjectPackageWiseData = useCallback(async () => {
                console.log('fetchProjectPackageWiseData called', { reportType, selectedUnits });

                if (!reportType) {
                        console.log('No reportType selected');
                        setProjectPackageData([]);
                        setProjectPackageLabels([]);
                        return;
                }

                if (!selectedUnits || selectedUnits?.length === 0) {
                        console.log('No units selected');
                        setProjectPackageData([]);
                        setProjectPackageLabels([]);
                        return;
                }

                // const filteredUnits = selectedUnits.filter((unit) => unit !== 'All');
                // if (filteredUnits.length === 0) {
                //         console.log('No valid units after filtering');
                //         setProjectPackageData([]);
                //         setProjectPackageLabels([]);
                //         return;
                // }

                // const mnfUnits = filteredUnits.join(', ');
                // console.log('Calling Project Package API with params:', { MNF_UNIT: mnfUnits, report_type: reportType });

                try {
                        const response = await axiosInstance.get('/api/admin/unit-level-project-package-wise', {
                                params: {
                                        MNF_UNIT: selectedUnits,
                                        report_type: reportType,
                                },
                        });

                        console.log('Project Package API Response:', response.data);

                        if (response.data?.status === 'success') {
                                setProjectPackageLabels(response.data.data?.labels || []);
                                transformProjectPackageData(response.data.data?.items || []);
                        } else {
                                openNotification('error', 'Error', response.data?.message || 'Failed to fetch data');
                                setProjectPackageData([]);
                                setProjectPackageLabels([]);
                        }
                } catch (error) {
                        console.error('Error fetching project package wise data:', error);
                        openNotification('error', 'Error', error?.response?.data?.message || 'Failed to fetch data');
                        setProjectPackageData([]);
                        setProjectPackageLabels([]);
                }
        }, [reportType, selectedUnits, transformProjectPackageData]);

        // Fetch package project wise data
        const fetchPackageProjectWiseData = useCallback(async () => {
                console.log('fetchPackageProjectWiseData called', { reportType, selectedUnits });

                if (!reportType) {
                        console.log('No reportType selected');
                        setPackageProjectData([]);
                        setLabels([]);
                        return;
                }

                if (!selectedUnits) {
                        console.log('No units selected');
                        setPackageProjectData([]);
                        setLabels([]);
                        return;
                }

                // const filteredUnits = selectedUnits.filter((unit) => unit !== 'All');
                // if (filteredUnits.length === 0) {
                //         console.log('No valid units after filtering');
                //         setPackageProjectData([]);
                //         setLabels([]);
                //         return;
                // }

                // const mnfUnits = filteredUnits.join(', ');
                // console.log('Calling API with params:', { MNF_UNIT: mnfUnits, report_type: reportType });

                try {
                        const response = await axiosInstance.get('/api/admin/unit-level-package-project-wise', {
                                params: {
                                        MNF_UNIT: selectedUnits1,
                                        report_type: reportType1,
                                },
                        });


                        if (response.data?.status === 'success') {
                                setLabels(response.data.data?.labels || []);
                                transformDataForTable(response.data.data?.items || []);
                        } else {
                                openNotification('error', 'Error', response.data?.message || 'Failed to fetch data');
                                setPackageProjectData([]);
                                setLabels([]);
                        }
                } catch (error) {
                        console.error('Error fetching package project wise data:', error);
                        openNotification('error', 'Error', error?.response?.data?.message || 'Failed to fetch data');
                        setPackageProjectData([]);
                        setLabels([]);
                }
        }, [reportType1, selectedUnits1, transformDataForTable]);

        // Fetch Project Package Wise data when its filters change
        useEffect(() => {
                if (reportType && selectedUnits) {
                        setLoading(true);
                        fetchProjectPackageWiseData().finally(() => {
                                setLoading(false);
                        });
                } else {
                        setProjectPackageData([]);
                        setProjectPackageLabels([]);
                        setLoading(false);
                }
        }, [reportType, selectedUnits, fetchProjectPackageWiseData]);

        // Fetch Package Project Wise data when its filters change
        useEffect(() => {
                if (reportType1 && selectedUnits1) {
                        setLoading1(true);
                        fetchPackageProjectWiseData().finally(() => {
                                setLoading1(false);
                        });
                } else {
                        setPackageProjectData([]);
                        setLabels([]);
                        setLoading1(false);
                }
        }, [reportType1, selectedUnits1, fetchPackageProjectWiseData]);

        
        return (
                <div className="pb-14">
                        <div className="px-5 flex flex-col gap-6 pt-6 pb-[34px]">
                                <Breadcrumb />
                                <div className="flex justify-between items-center">
                                        {/* Header Section - Left */}
                                        <div className="flex gap-3">
                                                <img
                                                        src={ReportPageIcon}
                                                        alt="reports"
                                                />
                                                <div>
                                                        <div className="font-inter font-semibold text-[24px] leading-[32px] tracking-[0%] text-[#101828]">Unit Level Report</div>
                                                        <div className="font-inter font-normal text-[14px] leading-[24px] tracking-[0%] text-[#475467]">View and analyze unit-level reports</div>
                                                </div>
                                        </div>

                                        {/* Filter Section - Right */}
                                        <div className="flex gap-[8px] items-center">
                                                <style>
                                                        {`
                                                                .report-type-select .ant-select-arrow {
                                                                        top: 50% !important;
                                                                        transform: translateY(-50%) !important;
                                                                        padding-top: 0 !important;
                                                                        margin-top: 0 !important;
                                                                }
                                                                .report-type-select .ant-select-selector {
                                                                        height: 50px !important;
                                                                        display: flex !important;
                                                                        align-items: center !important;
                                                                }
                                                        `}
                                                </style>
                                                <div className="report-type-select">
                                                        <Select
                                                                options={reportTypeOptions}
                                                                placeholder="Select Report Type"
                                                                value={reportType}
                                                                onChange={handleReportTypeChange}
                                                                className="!h-[50px] w-[200px]"
                                                        />
                                                </div>
                                                 <div className="report-type-select">
                                                <Select
                                                        
                                                        className="!h-[50px] w-[200px]"
                                                        options={
                                                                Array.isArray(allUnitListing)
                                                                        ? allUnitListing?.map((value) => ({
                                                                                  value: value?.MNF_UNIT,
                                                                                  label: value?.UNIT_DISPLAY_NAME,
                                                                          }))
                                                                        : []
                                                        }
                                                        value={selectedUnits}
                                                        onChange={handleUnitsChange}
                                                />
                                                </div>
                                        </div>
                                </div>

                                {/* {loading ? (
                                        <div className="flex justify-center items-center">
                                                <Loader />
                                        </div>
                                ) : ( */}
                                        <>
                                                {/* Project Package Wise Report Table */}
                                                <div className="mt-6">
                                                        <div className="font-inter font-semibold text-[18px] leading-[24px] text-[#101828] mb-4">Project Package Wise Report</div>
                                                        <div className="bg-white border border-gray-200 rounded-lg p-4">
                                                                {projectPackageData?.length === 0 && reportType && selectedUnits > 0 ? (
                                                                        <div className="text-center text-gray-500 py-8">No data available</div>
                                                                ) : !reportType ? (
                                                                        <div className="text-center text-gray-500 py-8">Please select Report Type and Units/Regions to view data</div>
                                                                ) : (
                                                                        <Table
                                                                                columns={generateProjectPackageColumns(projectPackageLabels)}
                                                                                dataSource={projectPackageData}
                                                                                pagination={false}
                                                                                bordered
                                                                                className="custom-ant-table"
                                                                                scroll={{ x: 'max-content', y: 400 }}
                                                                                rowClassName={(record, index) => 'table-row-light'}
                                                                                loading={loading}
                                                                        />
                                                                )}
                                                        </div>
                                                </div>
                                                
                                                {/* filter for project wise */}
                                                   <div className="flex gap-[8px] items-center justify-end">
                                                <style>
                                                        {`
                                                                .report-type-select .ant-select-arrow {
                                                                        top: 50% !important;
                                                                        transform: translateY(-50%) !important;
                                                                        padding-top: 0 !important;
                                                                        margin-top: 0 !important;
                                                                }
                                                                .report-type-select .ant-select-selector {
                                                                        height: 50px !important;
                                                                        display: flex !important;
                                                                        align-items: center !important;
                                                                }
                                                        `}
                                                </style>
                                                <div className="report-type-select">
                                                        <Select
                                                                options={reportTypeOptions}
                                                                placeholder="Select Report Type"
                                                                value={reportType1}
                                                                onChange={handleReportTypeChange1}
                                                                className="!h-[50px] w-[200px]"
                                                        />
                                                </div>
                                                <div className="report-type-select">

                                                <Select
                                                        label="Units/Regions"
                                                        options={
                                                                Array.isArray(allUnitListing)
                                                                        ? allUnitListing?.map((value) => ({
                                                                                  value: value?.MNF_UNIT,
                                                                                  label: value?.UNIT_DISPLAY_NAME,
                                                                          }))
                                                                        : []
                                                        }
                                                        value={selectedUnits1}
                                                        onChange={handleUnitsChange1}
                                                        className="!h-[50px] w-[200px]"

                                                        />
                                                        </div>

                                        </div>
                                                {/* Package Project Wise Report Table */}
                                                <div className="mt-6">
                                                        <div className="font-inter font-semibold text-[18px] leading-[24px] text-[#101828] mb-4">Package Project Wise Report</div>
                                                        <div className="bg-white border border-gray-200 rounded-lg p-4">
                                                                {packageProjectData?.length === 0 && reportType1 && selectedUnits1?.length > 0 ? (
                                                                        <div className="text-center text-gray-500 py-8">No data available</div>
                                                                ) : !reportType1  ? (
                                                                        <div className="text-center text-gray-500 py-8">Please select Report Type and Units/Regions to view data</div>
                                                                ) : (
                                                                        <Table
                                                                                columns={generatePackageProjectColumns(labels)}
                                                                                dataSource={packageProjectData}
                                                                                pagination={false}
                                                                                bordered
                                                                                className="custom-ant-table"
                                                                                scroll={{ x: 'max-content', y: 400 }}
                                                                                loading={loading1}
                                                                                rowClassName={(record, index) => 'table-row-light'}
                                                                        />
                                                                )}
                                                        </div>
                                                </div>
                                        </>
                                {/* )} */}
                        </div>
                </div>
        );
};

export default UnitLevelReportPage;
